import { Trans } from '@lingui/macro';
import { Box, Typography } from '@material-ui/core';
import CancelIcon from '@material-ui/icons/Cancel';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

import FormSection from '../../form/FormSection';
import VoipKeyValueDetails from './VoipKeyValueDetails';
import { useDetailStyles } from './VoipCallManagersStyles';

export default function VoipAgentRegistrationSection({ registrationDetail }) {
    const classes = useDetailStyles();
    const detail = registrationDetail || {};
    const registrationHasInfo = detail?.hasRegistrationInfo;

    if (!registrationHasInfo) {
        return null;
    }

    const registrationHasStatus = detail?.hasRegistrationStatus;
    const registrationStatus = detail?.registrationStatus;
    const registrationIsRegistered = detail?.isRegistered;
    const registrationLastDttm = detail?.registrationLastDttm;
    const registrationErrorObject = detail?.registrationErrorObject;
    const registrationText = registrationLastDttm
        ? `${registrationStatus} - ${registrationLastDttm}`
        : registrationStatus;

    return (
        <FormSection title={<Trans>Registration Information</Trans>}>
            {!registrationHasStatus && <Typography variant="subtitle2">{detail?.noVoIPRegistrationMessage}</Typography>}

            {registrationHasStatus && (
                <Box display="flex" alignItems="center" gridGap={12} mt={2}>
                    {registrationIsRegistered ? <CheckCircleIcon color="secondary" /> : <CancelIcon color="error" />}
                    <Typography variant="h6">{registrationText}</Typography>
                </Box>
            )}

            {!registrationIsRegistered && registrationErrorObject && (
                <div className={classes.keyValueContainer}>
                    <Typography variant="subtitle2">
                        <Trans>Registration Details</Trans>
                    </Typography>
                    <VoipKeyValueDetails details={registrationErrorObject} />
                </div>
            )}
        </FormSection>
    );
}
